import { render, staticRenderFns } from "./ServiceVehicleSupplierViewInformation.vue?vue&type=template&id=94e4581c&"
import script from "./ServiceVehicleSupplierViewInformation.vue?vue&type=script&lang=js&"
export * from "./ServiceVehicleSupplierViewInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports